module.exports = __webpack_public_path__ + "img/台東縣.3f30cf7b.png";